import React, { FC, memo, useEffect, useState } from "react";
import "./DraftingHeader.scss";
import Button, { EButtonSize, EButtonType } from "../../../../Components/Buttons/Button";
import caretLeftIcon from '../../../../Assets/icons/caret-left.svg';
import floppyIcon from '../../../../Assets/icons/floppy-disk.svg';
import pencilIcon from '../../../../Assets/icons/pencil-simple-line.svg';
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";
import TextEdit from "../../../../Components/TextEdit/TextEdit";
import { useTranslation } from "react-i18next";
import DownloadButton, { EDownloadSource } from "../Download/DownloadButton";
import { EToastPosition, EToastType, useToast } from "../../../../Components/Toast/Toast";
import { EDownloadFileExtention } from "../Download/DownloadApiCall";
import SupportButton from "../../../../Components/Support/SupportButton";

export enum EDraftingHeaderSource {
    TEMPLATE,
    DRAFT
}

interface IDraftingHeaderProps {
    id: string;
    name: string;
    type: string;
    jurisdiction: string;
    source?: EDraftingHeaderSource;
    areHiddenClausesVisible?: boolean;
    updateName?: (name: string) => void;
    setHiddenClausesVisible?: (isVisible: boolean) => void;
}

const DraftingHeader: FC<IDraftingHeaderProps> = ({ id, name, areHiddenClausesVisible, source, updateName, setHiddenClausesVisible }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const toast = useToast();

    const [ editableName, setEditableName ] = useState(name);

    useEffect(() => {
        setEditableName(name);
    }, [name]);

    const onBackClick = () => {
        navigate(-1)
    }

    const onSaveClick = () => {
        toast.show(t('drafting.saved'), EToastType.SUCCESS, EToastPosition.TOP);
    }

    const onNameChange = (value: string) => {
        setEditableName(value);
        updateName(value);
    }

    const getDownloadSource = () => {
        switch(source) {
            case EDraftingHeaderSource.TEMPLATE:
                return EDownloadSource.TEMPLATE;
            case EDraftingHeaderSource.DRAFT:
                return EDownloadSource.DRAFT;
        }
    }

    return (
        <div className={`drafting-header-container`}>
            { !process.env.REACT_APP_IS_RESELLER && <Button
                text={t("back")}
                buttonType={EButtonType.SECONDARY}
                size={EButtonSize.SMALL}
                iconLeft={caretLeftIcon}
                iconSize={16}
                onClick={onBackClick}
            />}
            <div className="dh-title-icon">
                <ReactSVG className="dh-title-icon" src={pencilIcon} />
            </div>
            <TextEdit 
                value={editableName}
                setValue={(value) => {onNameChange(value); } }
                type="text"
                placeholder="Name"
                edit={false}
            />
            <div className="dh-button-right">
                {source === EDraftingHeaderSource.DRAFT && <>
                    <DownloadButton downloadId={id} filename={name} extension={EDownloadFileExtention.PDF} source={getDownloadSource()}/>
                    <DownloadButton downloadId={id} filename={name} extension={EDownloadFileExtention.WORD} source={getDownloadSource()}/>
                </>
                }
                {/* {source === EDraftingHeaderSource.DRAFT && <VisibilityToggle isVisible={areHiddenClausesVisible} setIsVisible={setHiddenClausesVisible}/>} */}
                <SupportButton subject={ id } feature={ source === EDraftingHeaderSource.DRAFT ? "drafts" : "smart_templates" } />
            </div>
        </div>
    )
}

export default memo(DraftingHeader);